import {Outlet} from "react-router-dom";
import React from "react";

export default function AppLayout() {
    return (
        <div className="main">
            <Outlet />
        </div>
    )
}